export default __webpack_public_path__ + "static/media/0156IMG_2835.defbf756.jpg";